import { Project } from '@arra/core';

export const getServiceType = (modelType?: string) => {
  return modelType ?? 'other';
};

export const getPageName = (pathname: string) => {
  if (pathname.includes('/actions')) return 'actions';
  if (pathname.includes('/results')) return 'results';
  if (pathname.includes('/projects/')) return 'projects';
  if (pathname.includes('/project/')) return 'project';
  if (pathname.includes('/authentication/register')) return 'register';
  if (pathname.includes('/authentication/login')) return 'login';
  return 'dashboard';
};

export const getServiceTypeFromProject = (project?: Project) =>
  getServiceType(project?.model?.type);
